import { trackerActionTypes } from '@Actions/trackerActions';
import { takeLatest, all, select } from 'redux-saga/effects';
import { notification } from 'antd';
import mixpanel from 'mixpanel-browser';

/**
 * @param action
 */
function* _trackAction(action) {
  try {
    const data = yield select();
    const user = data?.UserReducers?.user;
    if (!(window.location.href.includes('localhost') || window.location.href.includes('elephant-org'))) {
      mixpanel.init('fe62bd9ba5dc5b27ab7e87eaaa00cb0e');
      mixpanel.identify(user?.username);
      const payload = {
        org_id: user?.tenant_info?.org_id,
        organisation_name: user?.tenant_info?.organisation_name,
        user_id: user?.tenant_info?.user_id,
        tenant_id: user?.tenant_info?.tenant_id,
        tenant_name: user?.tenant_info?.tenant_name,
        tenant_gst: user?.tenant_info?.gst_number,
        tenant_address: `${user?.tenant_info?.default_billing_address_info?.address1 || ''} ${user?.tenant_info?.default_billing_address_info?.city || ''} ${user?.tenant_info?.default_billing_address_info?.state || ''}`,
        role_id: user?.tenant_info?.permission?.tenant_role_id,
        role_name: user?.tenant_info?.permission?.tenant_role_name,
        tenant_department_id: user?.tenant_info?.permission?.tenant_department_id,
        tenant_department_name: user?.tenant_info?.permission?.tenant_department_name,
        department_id: user?.tenant_info?.department_id,
        department_name: user?.tenant_info?.department_id,
        side_menu_bar_type: user?.side_menu_bar_type,
        ...action?.data,
      };
      mixpanel?.track(action?.actionType, payload);
      window.userpilot?.track(action?.actionType, payload);
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* trackAction() {
  yield takeLatest(trackerActionTypes.TRACK_ACTION.REQUEST, _trackAction);
}

/**
 * @param action
 */
function* _identifyAction() {
  try {
    const data = yield select();
    const user = data?.UserReducers?.user;
    window.Intercom('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'zhm1nuf9',
      user_id: user?.username,
      name: user?.first_name,
      email: user.email,
      created_at: user.created_date,
      company: {
        id: user?.tenant_info?.org_id,
        name: user?.tenant_info?.organisation_name,
      },
      hide_default_launcher: true,
    });
    if (!(window.location.href.includes('localhost')
      || window.location.href.includes('elephant-org'))) {
      mixpanel.init('fe62bd9ba5dc5b27ab7e87eaaa00cb0e');
      mixpanel.identify(user?.username);
      mixpanel.people.set('$email', user?.username);
      mixpanel.people.set('$first_name', user?.first_name);
      mixpanel.people.set('$last_name', user?.last_name);
      mixpanel.people.set('$phone', user?.mobile);
      mixpanel.set_group('org_id', user?.tenant_info?.org_id);
      mixpanel.set_group('organisation_name', user?.tenant_info?.organisation_name);
      pendo.initialize({
        visitor: {
          id: user?.username,
          email: user?.username,
          full_name: user?.first_name,
          phone: user?.mobile,
        },
        account: {
          id: user?.tenant_info?.org_id,
          name: user?.tenant_info?.organisation_name,
          is_paying: true,
          isadmin: !!user?.org_id,
        },
      });

      Featurebase(
        'identify',
        {
          organization: 'procuzy', // required
          email: user?.email, // required
          name: user?.first_name, // required
          id: user?.username, // required
          userHash: user.feature_base_user_hash,
          companies: [
            {
              id: user?.tenant_info?.org_id?.toString(),
              name: user?.tenant_info?.organisation_name, // required
            },
          ],
        },
        (err) => {
          Featurebase('initialize_feedback_widget', {
            organization: 'procuzy', // required
            theme: 'light', // required
            placement: 'right', // optional
            email: user?.email, // optional
            userHash: user.feature_base_user_hash,
          });
          if (err) {
            console.log('Data', err);
          } else {
            console.log('Data sent successfully!');
          }
        },
      );
      Featurebase('initialize_changelog_widget', {
        organization: 'Procuzy',
        theme: 'light',
        fullscreenPopup: true,
        usersName: `${user?.first_name} ${user?.last_name}`?.trim(),
        userHash: user.feature_base_user_hash,
      });

      // example with company attributes
      window.userGuiding.identify(user?.username, {
        email: user?.username,
        name: user?.first_name,
        phone: user?.mobile,
        company: {
          id: user?.tenant_info?.org_id?.toString(),
          name: user?.tenant_info?.organisation_name,
        },
      });

      // example with company attributes
      window.userpilot.identify(user?.username, {
        name: user?.username,
        email: user?.username,
        phone: user?.mobile,
        company: {
          id: user?.tenant_info?.org_id?.toString(),
          name: user?.tenant_info?.organisation_name,
        },
      });
    }
  } catch (error) {
    // notification.open({
    //   type: 'error',
    //   message: error.message,
    //   duration: 4,
    //   placement: 'top',
    // });
  }
}

/**
 *
 */
function* identifyAction() {
  yield takeLatest(trackerActionTypes.IDENTIFY_ACTION.REQUEST, _identifyAction);
}

/**
 * @param action
 */
function* _pageAction(action) {
  try {
    const data = yield select();
    const user = data?.UserReducers?.user;
    const payload = {
      tenant_id: user?.tenant_info?.tenant_id,
      tenant_name: user?.tenant_info?.tenant_name,
      tenant_gst: user?.tenant_info?.gst_number,
      tenant_address: `${user?.tenant_info?.default_billing_address_info?.address1 || ''} ${user?.tenant_info?.default_billing_address_info?.city || ''} ${user?.tenant_info?.default_billing_address_info?.state || ''}`,
      role_id: user?.tenant_info?.permission?.tenant_role_id,
      role_name: user?.tenant_info?.permission?.tenant_role_name,
      tenant_department_id: user?.tenant_info?.permission?.tenant_department_id,
      tenant_department_name: user?.tenant_info?.permission?.tenant_department_name,
      department_id: user?.tenant_info?.department_id,
      department_name: user?.tenant_info?.department_id,
      side_menu_bar_type: user?.side_menu_bar_type,
      page: action?.page,
    };
    if (!(window.location.href.includes('localhost') || window.location.href.includes('elephant-org'))) {
      mixpanel.track_pageview(payload);
    }
  } catch (error) {
    console.log(error);
  }
}

/**
 *
 */
function* pageAction() {
  yield takeLatest(trackerActionTypes.PAGE_ACTION.REQUEST, _pageAction);
}

/**
 *
 */
export default function* trackerSaga() {
  yield all([
    trackAction(),
    identifyAction(),
    pageAction(),
  ]);
}
